module.exports = __webpack_public_path__ + "static/media/hamburgButton.f8b5dccf.svg";